import React from 'react';
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBCarouselElement,
  MDBCarouselCaption,
} from 'mdb-react-ui-kit';
// import { Box, Hidden, Paper, Typography, Container, Grid, } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@emotion/react";
import TestimonialBackgroundImage from "../../../assets/testimonial-background-image.png";
import { StarIcon } from "../../icons";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Card, CardContent, CardMedia, Typography,Box, Grid, Container, Rating } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const testimonials = [
  {
    id: 1,
    name: 'Molly P.',
    rating: 5,
    role: 'Parent',
    testimonial: "I took my daughter to a weekly tutoring session for most of her 6th grade year. Over the last 4 months we've switched to Word Voyage tutoring with wonderful results. For one thing it is much more convenient and the monthly cost is less than the weekly cost at the tutoring center. I like Word Voyage's old school, back to basics approach. On top of this, the tutor has helped her with grammar and sentence writing. I can't recommend Word Voyage enough!",
  },
  {
    id: 2,
    name: 'Laura Micetich',
    rating: 4,
    role: 'University School of Jackson, Jackson, TN',
    testimonial: "Word Voyage has proven an invaluable tool in my classroom as a first-year middle school English teacher. My students are both engaged and challenged by the programs and their vocabulary has flourished. Not only am I able to personalize our lessons to complement the rest of our English curriculum, but Whit responds with lightning fast speed to any questions or issues that arise. I have nothing but the highest praise for this program and Whit.",
  },
  {
    id: 3,
    name: 'Cynthia W.',
    rating: 5,
    role: 'Parent',
    testimonial: "My son just completed 4 months of work with a Word Voyage tutor. The content was definitely challenging for him, but the tutor quickly adjusted the lessons to make them manageable. I loved the instruction in Latin roots and root families- these will be very helpful on the SAT. It's also wonderful to see how much his grammar improved. He's now correcting my grammar all the time! The continual support and positive reinforcement from the tutor was truly remarkable!",
  },
  {
    id: 4,
    name: 'John Guevremont',
    rating: 3,
    role: 'English Department Chair, Mount St. Charles Academy Woonsocket, RI',
    testimonial: "Thought you'd like to know. Now that kids take a version of PSAT from grades 8-11 we are given info as to how they met the college readiness benchmark. All of our classes scored 96% or better on Verbal. I could not be more happy with customer service at Word Voyage. They have responded to all my questions, requests, and suggestions with alacrity. I am amazed at the promptness with which they have created customized word lists on demand for our literature and subject-specific curriculum.",
  },
  {
    id: 5,
    name: 'Julia Keller',
    rating: 3,
    role: 'English teacher at KIPP Central City, New Orleans',
    testimonial: "Historically, our students have had relatively low scores on the Vocabulary section of the ELA MAP test, and despite numerous interventions, we haven't had success moving those scores. This year we piloted Word Voyage in 7th grade ELA, and were very impressed with the results. Fall-Winter Vocabulary growth was significantly higher than that of Info/Literacy (5 points of RIT growth). The average vocabulary RIT score is also higher than any other cohort has historically been at this point in their 7th-grade year.",
  },
  {
    id: 6,
    name: 'Bob England',
    rating: 3,
    role: 'Assistant Principal, Medomak Middle School, Waldoboro, Maine',
    testimonial: "This year we are using Word Voyage for all 7th-9th students and all special education students 7-12. At the half-year point we have seen significant growth in NWEA scores for all students. One teacher indicated: Wow- every kid has already had a year's growth! This is just what we needed as we were behind a grade level with one-third of the population. The results are so compelling that next year we will be extending our Word Voyage license to grades 4-9 for all students.",
  },
  {
    id: 7,
    name: 'Ashley Fitzpatric',
    rating: 3,
    role: 'Sycamore Community City School District, Cincinnati, Ohio',
    testimonial: "My name is Ashley Fitzpatric and I teach 3rd and 4th grade Advanced Language Arts in the Sycamore Community City School District a suburb of Cincinnati, Ohio. When I read these testimonials I often wonder if it was a real person who actually taught in the classroom year after year and was living with pressures of State Testing and high expectations. If there ever was such a teacher it is me. I understand we don't have time for programs that don't make an impact, target standards or that make our kids miserable because that never helped anyone! I assure you I am real:-) I have used Word Voyage for over five years...nearly the beginning of its widespread use on the educational market. When my colleagues and I started using this product it was so new I could e-mail the creator and he'd e-mail me back within minutes (and he still does for the record). When you use Word Voyage if you need help, have questions or there is an issue they will be there. You are not left sorting out yet another program. Word Voyage is diverse and incredibly customizable to the academic needs of students as well as the programming you hope to achieve. It covers roots, word cousins, syllables, definitions, parts of speech, games and the list goes on and on until you are forced to make decisions. This is why we go back each year. Teachers can include or exclude all of these parts as needed. The word lists are rich, quizzes are included, you can weight the work and quizzes as you like and it even grades work/quizzes for you (AMEN!!!) The best part....to do these things you just click choices on a list-that's it literally. You don't need more than two minutes. I use Word Voyage on a weekly basis. Students are assigned each unit due in about a week's time so students must manage their time for more than one night. Although, perhaps not intended, I feel I am able to give students age appropriate executive functioning skills practice as a natural result of implementing Word Voyage. A win/win for kids and teachers. The long term impact of Word Voyage and how it translates to writing and test scores is evident to me through the sentence writing component of Word Voyage. The sentence writing component requires the students to use the word in a sentence, which I then require to include context clues. The sentences then must be approved by me before the quiz. This requirement changes vocabulary/root work instruction from being a memorization activity to being one of application and practice in writing. A game changer. This gets at those hard vocabulary questions where kids must use context clues to define words on standardized tests and it provides authentic experience to learning words and being able to really use new vocabulary. The transformation from the start to end of the year is astounding.",
  },
  {
    id: 8,
    name: 'Lori Klima',
    rating: 3,
    role: 'Gifted Specialist, Montgomery Elementary, Sycamore Community Schools',
    testimonial: "My district has used Word Voyage with our third and fourth graders in gifted language arts classes. The vocabulary list is a great mix of words they’ve heard of and new ones to learn about. We have created our list from the vocabulary given, but I know it can utilize other words connected with certain books or even words of our choice. Our test scores in vocabulary have gone up. I love to see how the kids grow in their understanding of the Greek and Latin roots and how they’re the building blocks of so much of the English language. I love to see the kids understand the ideas of the roots and apply them to what they’re decoding and reading. “I see the root jud and I know that means judge, so judicious must have something to do with judging.” Lastly, it is user friendly and doesn’t glitch. It is very manageable for teachers. The kids love the games and will challenge each other. Whit Symmes is the greatest consultant, always answering our questions and being helpful. I recommend it whole-heartedly.",
  },
  {
    id: 9,
    name: 'Joy Lenters',
    rating: 3,
    role: 'The Mead School, Stamford, CT',
    testimonial: "Word Voyage is the most comprehensive, customizable vocabulary program ever, and it's geared to respond to the most up to date brain research on how students learn. They have added a grammar component which the teacher can further customize to match their own grammar curriculum, giving students the active practice they need to master grammar, punctuation and syntax rules. Support and training are embedded in the program, so any teacher can get immediate help if they forget how to set anything up - but the logic is easy to use, even for us digital dummies. Kids love the games they can play with and against each other. Teachers love the quality control and knowledge that their students are truly learning and retaining vocabulary as well as practicing usage. It's a win-win!",
  },
  {
    id: 10,
    name: 'Karen Anderson',
    rating: 3,
    role: 'Wise School, Los Angeles, CA',
    testimonial: "You have been so great with us and we are looking forward to another great year. Guess what? Our ERB Vocabulary scores improved 16% last year!",
  },
  // {
  //   id: 4,
  //   name: 'John Guevremont',
  //   rating: 3,
  //   role: 'En',
  //   testimonial: "tm.",
  // },
  // {
  //   id: 4,
  //   name: 'John Guevremont',
  //   rating: 3,
  //   role: 'En',
  //   testimonial: "tm.",
  // },
  // {
  //   id: 4,
  //   name: 'John Guevremont',
  //   rating: 3,
  //   role: 'En',
  //   testimonial: "tm.",
  // },
  // {
  //   id: 4,
  //   name: 'John Guevremont',
  //   rating: 3,
  //   role: 'En',
  //   testimonial: "tm.",
  // },
  // {
  //   id: 4,
  //   name: 'John Guevremont',
  //   rating: 3,
  //   role: 'En',
  //   testimonial: "tm.",
  // },
  // Add more testimonials as needed
];

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 450,
    margin: 'auto',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
    transition: '0.3s',
    borderRadius: '10px',
  },
  icon: {
    fontSize: 50,
    color: theme.palette.primary.main,
  },
  content: {
    padding: theme.spacing(2),
    height: '570px', // Set the maximum height for card content
    overflowY: 'auto', // Enable scrolling for card content if it exceeds the maxHeight
    backgroundColor: '#ffe'
  },
  carouselContainer: {
    maxWidth: '100%',
    padding: theme.spacing(2), // Adjust spacing as needed
  },
  rating: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  starIcon: {
    color: theme.palette.warning.main,
    marginRight: theme.spacing(1),
  },
  customArrow: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    cursor: 'pointer',
    fontSize: '2rem',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '50%',
    padding: '8px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
  customArrowLeft: {
    left: '10px', // Adjust the position for the left arrow
  },
  customArrowRight: {
    right: '10px', // Adjust the position for the right arrow
  },
}));


export function DemoCarousel() {
    const { palette } = useTheme();
  const styles = useStyles();
  const classes = useStyles();

  // Split testimonials into groups of 2
  const groupedTestimonials = [];
  for (let i = 0; i < testimonials.length; i += 2) {
    groupedTestimonials.push(testimonials.slice(i, i + 2));
  }
  const customPrevArrow = (clickHandler) => (
    <div className={`${classes.customArrow} ${classes.customArrowLeft}`} onClick={clickHandler}>
      &lt; {/* Custom left arrow */}
    </div>
  );

  const customNextArrow = (clickHandler) => (
    <div className={`${classes.customArrow} ${classes.customArrowRight}`} onClick={clickHandler}>
      &gt; {/* Custom right arrow */}
    </div>
  );
  return (
    <Box pb={6}>
       <Box pt={15}>
        <Box width="100%" display="flex" justifyContent="center">
          <Typography variant="h1" color={palette.common.black}>
            What Our Customers Say
          </Typography>
        </Box>
        <Box width="100%" display="flex" justifyContent="center" pt={2} pb={2}>
        <Box >
              <Box
                bgcolor={palette.secondary.main}
                border={`4px solid ${palette.secondary.main}`}
                width="90px"
                borderRadius="4px"
              />
            </Box>
        </Box>
      </Box>
      <Box sx={{ background: `url(${TestimonialBackgroundImage}) no-repeat center center fixed` }} paddingY={5}>
        <Container maxWidth="lg" className={classes.carouselContainer}>
          <Carousel showArrows showThumbs={false} infiniteLoop={true} renderArrowPrev={customPrevArrow} renderArrowNext={customNextArrow} showStatus={false} emulateTouch={true} centerMode={true} showIndicators={false} centerSlidePercentage={100}>
            {groupedTestimonials.map((testimonialGroup, index) => (
              <Grid container spacing={1} key={index}>
                {testimonialGroup.map((testimonial) => (
                  <Grid item xs={12} sm={6} key={testimonial.id}>
                    <Card className={classes.card}>
                      <CardContent className={classes.content}>
                        <Box className={classes.rating}>
                          <Rating readOnly size="small" name='read-only' value={5} />
                        </Box>
                        <Box pt={1}>
                          <Typography component="p" variant="body4" textAlign="start">
                            {testimonial.testimonial}
                          </Typography>
                        </Box>
                        <Box pt={1}>
                          <Typography textAlign="start" paddingTop={1} paddingBottom={1} sx={{ fontWeight: 'bold' }} variant="body2" component="p">
                            {testimonial.name}
                          </Typography>
                        </Box>
                        <Box pt={1}>
                          <Typography component="p" variant="body4" textAlign="start">
                            {testimonial.role}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ))}
          </Carousel>
        </Container>
      </Box>
  </Box>

  );
}